import { Entity } from "../helpers/Entity"


export type DefaultOptionAttributesDto = {
    optionKey: string
    type: string
    value: string
    accountId: string
}

export type DefaultOptionDto = {
    id: string
    type: string
    attributes: DefaultOptionAttributesDto
}

export default class DefaultOption implements Entity {
    private dto: DefaultOptionDto
    constructor(dto: DefaultOptionDto) {
        this.dto = dto
    }
    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "proposal-default-options"
    }

    getId(): string {
        return this.dto.id
    }

    getOptionKey(): string {
        return  this.dto.attributes.optionKey
    }

    getValue(): string {
        return  this.dto.attributes.value
    }
}

export function getOptionValueWithOptionKey(defaultOptions: DefaultOption[], optionKey: string, defaultOptionValue: unknown) {
    const option = defaultOptions.find(o => o.getOptionKey() === optionKey)
    return option ? option.getValue() : defaultOptionValue
}


// WEBPACK FOOTER //
// ./src/state/default-option/DefaultOption.ts